<template>
  <div>
    <el-upload
        action="none"
        ref="upload"
        list-type="picture-card"
        :multiple="multiple"
        :accept="accept"
        :disabled="disabled"
        :file-list="postData"
        :on-preview="onPreview"
        :on-remove="onRemove"
        :on-success="onSuccess"
        :on-error="onError"
        :on-progress="onProgress"
        :on-change="onChange"
        :on-exceed="onExceed"
        :before-upload="beforeUpload"
        :http-request="uploadFile"
        :limit="limit"
    >
      <!--    <div>上传图片</div>-->
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      :modal-append-to-body="true"
      custom-class="pic-uploader-preview-dialog"
      @opened="onPreviewDialogOpened"
    >
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
import OSS from 'ali-oss';
var client = {};
export default {
  name: 'PicUploader',
  data(){
    return {
      postData: [],
      dialogImageUrl: '',
      dialogVisible: false,
      ossAccessTokenURL: 'https://bc-api.ccachina.net/core/attachment/aliOssSts',
      ossFileURL: 'https://bc2026.oss-ap-southeast-1.aliyuncs.com',
    }
  },
  props: {
    fileList: {
      type: Array,
      required: true,
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    multiple: {
      type: Boolean,
      required: false,
    },
    limit: {
      type: Number,
      default: 0,
    },
    drag: Boolean,
    disabled: Boolean,
    onError: Function,
    onProgress: Function,
    onChange: Function,
  },
  computed: {
  },
  mounted() {
    this.postData = this.fileList
  },
  watch: {
    fileList(value) {
      this.postData = value
    }
  },
  methods: {
    onRemove: function (file, fileList) {
      const that = this;
      this.fileList.forEach(function (element, index) {
        if (element.uid == file.uid) {
          that.fileList.splice(index, 1);
        }
      }, this);
    },

    onPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    /** 嵌套在其它 el-dialog 内时，将预览层 z-index 提到当前最高弹层之上 */
    onPreviewDialogOpened() {
      this.$nextTick(function () {
        var dialogEl = document.querySelector('.pic-uploader-preview-dialog');
        if (!dialogEl) {
          return;
        }
        var previewWrapper = dialogEl.parentElement;
        while (previewWrapper && previewWrapper.classList && !previewWrapper.classList.contains('el-dialog__wrapper')) {
          previewWrapper = previewWrapper.parentElement;
        }
        if (!previewWrapper) {
          return;
        }
        var wrappers = document.querySelectorAll('.el-dialog__wrapper');
        var maxZ = 2000;
        for (var i = 0; i < wrappers.length; i++) {
          var z = parseInt(window.getComputedStyle(wrappers[i]).zIndex, 10);
          if (!isNaN(z) && z > maxZ) {
            maxZ = z;
          }
        }
        var nextZ = maxZ + 10;
        previewWrapper.style.zIndex = String(nextZ);
        var modals = document.querySelectorAll('.v-modal');
        if (modals.length) {
          modals[modals.length - 1].style.zIndex = String(nextZ - 1);
        }
      });
    },

    onSuccess() {
    },

    onExceed(files, fileList) {
      this.$message.warning(`You can select up to ${this.limit} file(s). ${files.length} selected this time, ${files.length + fileList.length} in total.`);
    },

    beforeUpload(file) {
      // 文件大小限制
      const isLt5M = file.size / 1024 / 1024 < 16;
      if (!isLt5M) {
        this.$message.error('The image size must not exceed 16M');
        return false;
      }
    },

    uploadFile(evt){
      var that = this;
      console.log(that.ossFileURL);

      evt.onProgress({percent: 0});
      OSS.urllib.request(this.ossAccessTokenURL, {method: 'GET'}, function (err, response) {
        let result;
        if (err) {
          that.$message('上传异常:' + err);
          console && console.error(err);
          evt.onError(100);
          return;
        }
        try {
          result = JSON.parse(response);
        } catch (e) {
          return alert('parse sts response info error: ' + e.message);
        }

        console.log(that.ossAccessTokenURL,'result',result)

        client = new OSS({
          accessKeyId: result.data.AccessKeyId,
          accessKeySecret: result.data.AccessKeySecret,
          stsToken: result.data.SecurityToken,
          endpoint: result.data.endpoint,
          bucket: result.data.bucket,
          secure: true
        });
        var suffix = evt.file.name.toLowerCase().split('.').splice(-1)[0];
        console.log(that.ossFileURL);
        var myDate = new Date().getTime();
        let time = myDate + '' + (Math.floor(Math.random() * 1000 + 1));
        let date = that.dateFormat(myDate);
        var file_save_name = 'pc/' + date + '/' + time + '.' + suffix;
        console.log(file_save_name);

        client.multipartUpload(file_save_name, evt.file,{
          progress:function(p,checkpoint){
            console.log('----上传进度----')
            let progress = parseInt(p*100);
            evt.onProgress({percent: progress});
          },

        }).then(function (result) {
          evt.onSuccess();
          console.log(that.ossFileURL);
          var file = {
            url: that.ossFileURL + '/' + file_save_name,
            name: evt.file.name,
            save_name: file_save_name,
          }
          that.postData.push(file);

        }).catch(function (err) {
          console.log(err)
          that.$message({
            message: evt.file.name + ' upload failed',
            type: 'warning',
          });
        });
      });
    }
  }
}
</script>

<style>
/* 预览内容置于遮罩之上（append-to-body 后由 onPreviewDialogOpened 调整 wrapper 层级） */
.pic-uploader-preview-dialog {
  position: relative;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// PicUploader.vue?7c1e47a3